import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    enabled: Boolean
  }

  async toggle(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const originalText = btn.innerHTML
    
    btn.disabled = true
    btn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Обработка...'

    try {
      const response = await fetch(btn.dataset.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ enabled: btn.dataset.enabled === 'true' })
      })

      const data = await response.json()

      if (data.success) {
        // Regeneration will take time, but the ProcessingResultStatusController
        // will show the loading overlay soon. 
        // We can show a small hint here too.
        if (window.Toast) {
          window.Toast.fire({ icon: 'info', title: data.message })
        }
      } else {
        throw new Error(data.error || 'Unknown error')
      }
    } catch (error) {
      console.error('Error toggling extra jar exclusion:', error)
      alert('Ошибка: ' + error.message)
      btn.disabled = false
      btn.innerHTML = originalText
    }
  }
}
